export class TtsLocaleMap {

  constructor(
    public id: number,
    public xcoreLocale: string,
    public pollyLocale: string
  ) {
  }

}
